import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportClientError } from '../lib/system-status';
import { SystemErrorPage } from './SystemErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Catch unhandled React render errors and show the system fallback page. */
export class GlobalErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportClientError({
      kind: 'react_boundary',
      message: error.message,
      stack: error.stack,
      details: { componentStack: info.componentStack },
    });
  }

  override render() {
    if (this.state.hasError) {
      return <SystemErrorPage reason="unexpected" onRetry={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}
